import {
  TextInput,
  TextInputProps,
} from "@/flokit/compound/inputs/text-input/text-input";

export const NumericalEdit = (props: TextInputProps) => {
  return (
    <TextInput
      {...props}
      placeholder="Enter a number"
      type="number"
      value={`${props.value}`}
      onChange={props.onChange}
    />
  );
};
